export const SCREEN_XL_START = 1400;
export const SCREEN_LG_START = 1024;
export const SCREEN_MEDIUM_START = 786;
export const SCREEN_SMALL_START = 486;
export const inputFieldKeys = ["eingabeJson", "eingabeMehrfachAuswahlWerts", "eingabeMedien", "eingabeText", "eingabeZahl", "eingabeBoolean", "eingabeAuswahlWert"];

export const surveysPageSize = 25;